module.exports = __webpack_public_path__ + "img/logo-skills-group.df37d507.jpg";